import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noSpaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasSpace = /\s/.test(control.value); // Check if the value contains spaces
    return hasSpace ? { noSpace: true } : null; // Return error if spaces exist
  };
}